/**
 * AlongsidePhase - Phase 3 of voyage management
 */

import React from 'react';
import { CheckCircle } from 'lucide-react';

const AlongsidePhase = ({ 
  activeVoyage,
  logEntries,
  onCompleteVoyage
}) => {
  const formatDuration = (ms) => {
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    if (hours === 0) return `${minutes}m`;
    return `${hours}h ${minutes}m`;
  };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow">
        <div className="px-5 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Alongside - Post Voyage</h3>
          <p className="text-sm text-gray-500 mt-1">Complete post-voyage tasks</p>
        </div>
        
        <div className="p-5 space-y-4">
          {/* Arrival Checks */}
          <div className="p-4 rounded-lg bg-gray-50 border-2 border-gray-200">
            <h4 className="text-sm font-medium mb-2">Arrival Tasks</h4>
            <div className="space-y-2">
              <label className="flex items-center gap-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Engine shutdown procedures completed</span>
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Vessel secured alongside</span>
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Shore power connected (if applicable)</span>
              </label>
            </div>
          </div>

          {/* Voyage Summary */}
          <div className="p-4 rounded-lg bg-blue-50 border-2 border-blue-200">
            <h4 className="text-sm font-medium mb-2">Voyage Summary</h4>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-600">Total Duration:</span>
                <span className="ml-2 font-medium">
                  {activeVoyage && activeVoyage.actualDepartureTime && activeVoyage.actualArrivalTime ?
                    formatDuration(new Date(activeVoyage.actualArrivalTime) - new Date(activeVoyage.actualDepartureTime)) :
                    'N/A'}
                </span>
              </div>
              <div>
                <span className="text-gray-600">Log Entries:</span>
                <span className="ml-2 font-medium">{logEntries.length}</span>
              </div>
            </div>
          </div>

          {/* Hours of Work Entry */}
          <div className="p-4 rounded-lg bg-yellow-50 border-2 border-yellow-200">
            <h4 className="text-sm font-medium mb-2">Hours of Work</h4>
            <p className="text-xs text-gray-600 mb-3">
              Enter total work hours including shore duties, maintenance, etc.
            </p>
            <div className="space-y-3">
              {activeVoyage?.crewList?.map((member, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <span className="text-sm w-32">{member.name}:</span>
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    max="24"
                    placeholder="Hours worked"
                    className="px-3 py-1 border rounded text-sm w-24"
                  />
                  <input
                    type="text"
                    placeholder="Notes (shore duties, etc.)"
                    className="px-3 py-1 border rounded text-sm flex-1"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Complete Voyage Button */}
          <div className="mt-6 flex justify-center">
            <button
              onClick={onCompleteVoyage}
              className="px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 flex items-center gap-2"
            >
              <CheckCircle className="h-5 w-5" />
              Complete & Archive Voyage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlongsidePhase;